import { Price } from './models/price';

export enum PricingBreakdownAmountType {
  listingPrice = 'listingPrice',
  buyerFee = 'buyerFee',
  fullPrice = 'fullPrice',
}

export type ApiPricingBreakdown = {
  sellerPrice: Price;
  sellerEarning?: Price;
  buyerFees: BuyerFeesType;
  fullPrice?: Price;
};

export type PricingBreakdown = {
  fullPrice: Price;
  sellerInitialPrice?: Price;
} & ApiPricingBreakdown;

export type BuyerFeesType = {
  hasCrossBorderFees: boolean;
  includesAuthenticationFees: boolean;
} & Omit<FeesType, 'name'>;

export type FeesType = {
  name: string;
  feeType: 'percent' | 'cap' | 'flat';
  amount: {
    cents: number;
    currency: string;
    formatted: string;
  };
  percent: {
    value: number;
    formatted: string;
  };
  cap?: {
    type: 'min' | 'max';
    percent: {
      value: number;
      formatted: string;
    };
  };
};

export type BuyerFeesOnSellerSide = {
  hasCrossBorderFees: boolean;
};
